// src/ducks/poiFilters.duck.js
// Active POI categories, shared across all maps, persisted to localStorage.
// Default is empty (all toggles off) per design.

const STORAGE_KEY = 'vansite_poi_categories';

const canUseStorage = () =>
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const readStored = () => {
  if (!canUseStorage()) return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const writeStored = (ids) => {
  if (!canUseStorage()) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch {
    /* storage disabled / quota — ignore */
  }
};

// ====== Action types ======
export const SET_POI_CATEGORIES = 'app/PoiFilters/SET_POI_CATEGORIES';

// ====== Reducer ======
const initialState = { activeCategories: readStored() };

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_POI_CATEGORIES:
      return { ...state, activeCategories: payload };
    default:
      return state;
  }
}

// ====== Action creators ======
export const setPoiCategories = (ids) => ({ type: SET_POI_CATEGORIES, payload: ids });

export const togglePoiCategory = (id) => (dispatch, getState) => {
  const current = getState().poiFilters.activeCategories;
  const next = current.includes(id) ? current.filter(x => x !== id) : [...current, id];
  writeStored(next);
  dispatch(setPoiCategories(next));
};

// ====== Selectors ======
export const selectActivePoiCategories = (state) => state.poiFilters.activeCategories;
